import MontCards from "../components/MontCards/MontCards"
import "../App.css"



function MCPage (){
    return(
        <div className="pt-5">
            <h1 className="text-home2">MEDIA Y ALTA MONTAÑA</h1>
            <MontCards/>
            
        </div>
    )
}

export default MCPage